// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const updateUserStripeCustomerId = async ({
    test,
    stripeCustomerId,
}: {
    test: boolean,
    stripeCustomerId: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleUpdateUserStripeCustomerId = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        boolean
    >(
        functions,
        'updateUserStripeCustomerId',
    );
    return handleUpdateUserStripeCustomerId({
        test,
        stripeCustomerId,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default updateUserStripeCustomerId;
